'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        margin-left: ', ';\n        margin-right: ', ';\n        width: ', ';\n        max-width: ', ';\n      '], ['\n        margin-left: ', ';\n        margin-right: ', ';\n        width: ', ';\n        max-width: ', ';\n      ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  /** Set content flow direction */
  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  /** Fix row width */
  fixedWidth: _propTypes2.default.bool,
  /**
   * If true, Row will have negative margins to compensate Column gutters
   */
  compensateGutter: _propTypes2.default.bool,
  /** If true, content will wrap */
  wrapContent: _propTypes2.default.bool,
  /**
   * Set size ratio for row
   * @example Row with expandRatio={2} will take twice more size than Row
   * with expandRatio={1}
   */
  expandRatio: _propTypes2.default.number,
  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  layoutDirection: 'horizontal',
  compensateGutter: false,
  fixedWidth: false,
  wrapContent: false,
  expandRatio: 0.0
};

/** PROP RECEIVERS */
var width = function width(_ref) {
  var compensateGutter = _ref.compensateGutter,
      fixedWidth = _ref.fixedWidth,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var maxWidth = fixedWidth ? '' + (0, _reactackleCore.getValueString)(theme.reactackle.components.grid.row.maxWidth) : '100%';

  var gutter = (0, _reactackleCore.getValueString)(theme.reactackle.components.grid.column.gutterHorizontal);

  var defaultMargin = 'calc(-' + gutter + ' / 2})',
      gutterScale = theme.reactackle.components.grid.column.breakpoints;

  var gutteredMaxWidth = 'calc(' + maxWidth + ' - ' + gutter + ')';

  var breakpoints = gutterScale.map(function (item) {
    var margin = 'calc(-' + (0, _reactackleCore.getValueString)(item.gutterHorizontal) + ' / 2)';

    var width = 'calc(' + maxWidth + ' + ' + (0, _reactackleCore.getValueString)(item.gutterHorizontal) + ')';

    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, margin, margin, width, width));
  });

  return compensateGutter ? (0, _styledComponents.css)(['margin-left:', ';margin-right:', ';width:', ';max-width:', ';', ''], defaultMargin, defaultMargin, gutteredMaxWidth, gutteredMaxWidth, breakpoints) : '\n      margin: auto;\n      width: 100%;\n      max-width: ' + maxWidth + ';\n    ';
};

var contentFlow = function contentFlow(_ref2) {
  var layoutDirection = _ref2.layoutDirection,
      wrapContent = _ref2.wrapContent;

  var flexDirection = layoutDirection === 'horizontal' ? 'row' : 'column';
  var wrap = wrapContent && 'flex-wrap: wrap;';

  return '\n    flex-direction: ' + flexDirection + ';\n    ' + wrap + '\n  ';
};

var expand = function expand(_ref3) {
  var expandRatio = _ref3.expandRatio;
  return 'flex-grow: ' + expandRatio + ';';
};

var base = function base(_ref4) {
  var themeFromProvider = _ref4.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];

  return '\n    font-family: ' + fontFamily + ';\n    box-sizing: border-box;\n  ';
};

/** STYLES */
var RowStyled = exports.RowStyled = _styledComponents2.default.div.withConfig({
  displayName: 'RowStyled'
})(['display:flex;flex-shrink:0;', ' ', ' ', ' ', ';'], base, width, expand, contentFlow);

RowStyled.propTypes = propTypes;
RowStyled.defaultProps = defaultProps;
RowStyled.displayName = 'RowStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-grid/dist/Row/styles/RowStyled.js
// module id = 692
// module chunks = 0